import { createFileRoute } from '@tanstack/react-router'
import { TicketPriorityLevel } from '@/components/settings-route/ticket/priority-level/index.jsx'

export const Route = createFileRoute('/_auth/settings/tickets/priority')({
  component: TicketPriorityLevel,
})
